<div class="core-page-loader"></div>
<router-outlet></router-outlet>
<div class="core-notification"></div>
